// @flow
import * as React from 'react';
import type { ChildrenArray } from 'react';
import {
  types as t,
  usePropsValidation,
} from '../../validation/runtime-checks/index.js';
import type { CompilerInjectedProps } from '../../validation/runtime-checks/index.js';
import { InternalAnchor } from './internal-components.js';

export function INVDownloadableAssets(props: {|
  children: ChildrenArray<React$Element<typeof INVDownloadableAsset>>,
  ...CompilerInjectedProps,
|}) {
  const { children } = props;

  const { failedValidation } = usePropsValidation(props, INVDownloadableAssets);

  if (failedValidation) return null;

  return (
    <>
      Downloadable assets
      <ul style={{ margin: 0 }}>
        {React.Children.map(children, (child, idx) => (
          <li key={idx}>{child}</li>
        ))}
      </ul>
    </>
  );
}
INVDownloadableAssets.spec = {
  children: t.childrenArray(t.elementType(INVDownloadableAsset)),
};

export function INVDownloadableAsset(props: {|
  path: string,
  title: string,
  ...CompilerInjectedProps,
|}) {
  const { failedValidation } = usePropsValidation(props, INVDownloadableAsset);

  if (failedValidation) return null;

  const { path, title } = props;

  const S3_DIRECTORY =
    'https://jsx-images.mathspace.co/investigations/pdf-assets';

  return (
    <InternalAnchor url={`${S3_DIRECTORY}${path}`} title={title} option="pdf" />
  );
}
INVDownloadableAsset.spec = {
  path: pathChecker,
  title: t.string,
};

function pathChecker(props, propName) {
  const value = props[propName];

  const failure = t.string(props, propName);
  if (failure !== null) return failure;
  // Refinement for Flow as it doesn't know t.string enforces a string type
  if (typeof value !== 'string') {
    throw Error('runtime typecheck invariant failure');
  }

  const url = new URL(`http://fake${value}`);
  const versionId = url.searchParams.get('versionId');
  if (versionId === null) {
    return {
      typeDescription: pathChecker.description,
      reason:
        'must contain a versionId. Use the `Add pdf asset` tool to generate the correct jsx code.',
    };
  }

  return null;
}
pathChecker.description = 'BucketPath';
